import React from 'react';
import './InfoCard.css';

// Il componente accetta un titolo e il contenuto (i figli)
const InfoCard = ({ title, children }) => {
    return (
        <div className="info-card-container">
            <div className="info-card-header">
                {title}
            </div>
               <div className="sidebar-divider2"></div>
            <div className="info-card-body">
                {children}
            </div>
        </div>
    );
};

export default InfoCard;